module.exports = "/images/save-white.svg?9b503500cf5afaebc367990feae544d3";